import { AutogenLayoutAddBrokerageCodeMap } from "./autogen/AutogenLayoutAddBrokerageCodeMap";

export class AddBrokerageCodeMap extends AutogenLayoutAddBrokerageCodeMap {

    override onLoad() {

    }
}
